import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

function usuarioLoading(data) {
    return {
        type: 'USUARIO_LOADING',
        payload: data
    }
}

export function carregarUsuario(data) {
    return {
        type: 'USUARIO_FETCHED',
        payload: data
    }
}

export function carregarUsuarios(data) {
    return {
        type: 'USUARIOS_FETCHED',
        payload: data
    }
}

export function carregarUsuarioFuncionario(data) {
    return {
        type: 'USUARIO_FUNCIONARIO_FETCHED',
        payload: data
    }
}

export function carregarListaPerfilAdmin(data) {
    return {
        type: 'LISTA_PERFIL_ADMIN_FETCHED',
        payload: data
    }
}

export function carregarListaPerfil(data) {
    return {
        type: 'LISTA_PERFIL_FETCHED',
        payload: data
    }
}

export function carregarPerfilDeNegocioDoUsuario(data) {
    return {
        type: 'PERFIL_NEGOCIO_USUARIO_FETCHED',
        payload: data
    }
}

export function buscarUsuariosPorParteDoNome(nome) {
    return dispatch => {
        axios.get(`${URL}/usuarios/ativo/nome/${nome}`)
            .then(resp => dispatch(carregarUsuarios(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}

export function buscarUsuarioPorCpf(cpf) {
    return dispatch => {
        axios.get(`${URL}/usuarios/ativo/cpf/${cpf}`)
            .then(resp => dispatch(carregarUsuarioFuncionario(resp.data)))
            .catch(e => {
                const titulo = e.response.data.error || 'Erro inesperado';
                const msg = e.response.data.msg || 'Não foi possível pesquisar o CPF. Tente novamente em alguns instantes.';
                toastr.error(titulo, msg);
            })
    }
}

export function getUsuario(id) {
    return dispatch => {
        dispatch(usuarioLoading(true));
        axios.get(`${URL}/usuarios/${id}`)
            .then(resp => {
                dispatch(carregarUsuario(resp.data));
                dispatch(usuarioLoading(false));
            })
            .catch(e => {
                dispatch(usuarioLoading(false));
                toastr.error('Erro', e.message);
            });
    }
}

export function getUsuarios() {
    return dispatch => {
        dispatch(usuarioLoading(true));
        axios.get(`${URL}/usuarios/administracao/todos-usuarios/WEB`)
            .then(resp => {
                dispatch(carregarUsuarios(resp.data));
                dispatch(usuarioLoading(false));
            })
            .catch(e => {
                dispatch(usuarioLoading(false));
                toastr.error('Erro', e.message);
            });
    }
}

export function getUsuariosAtivos() {
    return dispatch => {
        dispatch(usuarioLoading(true));
        axios.get(`${URL}/usuarios/administracao/usuarios-ativos`)
            .then(resp => {
                dispatch(carregarUsuarios(resp.data));
                dispatch(usuarioLoading(false));
            })
            .catch(e => {
                dispatch(usuarioLoading(false));
                toastr.error('Erro', e.message);
            });
    }
}

export function addUsuario(values) {
    return dispatch => {
        axios.post(`${URL}/usuarios/administracao/novo-usuario`, values)
            .then(_ => dispatch(toastr.success('Sucesso', 'Usuário cadastrado com sucesso.')))
            .then(_ => dispatch(getUsuarios()))
            .catch(e => {
                try {
                    const data = e.response.data;
                    if(typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                }catch(e) {
                    return false;
                }
            })
    }
}

export function getPerfilDeNegocioDoUsuario(idUsuario) {
    return dispatch => {
        axios.get(`${URL}/usuarios/perfil-de-negocio/perfil-do-usuario/${idUsuario}`)
            .then(resp => dispatch(carregarPerfilDeNegocioDoUsuario(resp.data)))
            .catch(e => toastr.error('Erro', 'Não foi possível atualizar lista de funcionários. Erro: ' + e.message))
    }
}

export function getListaPerfilAdmin() {
    return dispatch => {
        axios.get(`${URL}/usuarios/perfil-admin`)
            .then(resp => dispatch(carregarListaPerfilAdmin(resp.data)))
            .catch(e => toastr.error('Erro', e.message));
    }
}

export function getListaPerfilDeNegocio() {
    return dispatch => {
        axios.get(`${URL}/usuarios/perfil-de-negocio`)
            .then(resp => dispatch(carregarListaPerfil(resp.data)))
            .catch(e => toastr.error('Erro', e.message));
    }
}

export function atualizarPerfilNegocioUsuario(values) {
    return dispatch => {
        axios.put(`${URL}/usuarios/definir-perfil-de-negocio`, values)
            .then(_ => toastr.success('Sucesso', 'Perfil definido com sucesso.'))
            .catch(e => toastr.error('Erro inesperado', 'Não foi possível definir o perfil do funcionário. Tente novamente em alguns instantes.'))
    }
}

export function atualizarPerfilUsuarioAdmin(values) {
    return dispatch => {
        axios.put(`${URL}/usuarios/gestao/definir-perfil`, values)
            .then(_ => toastr.success('Sucesso', 'Perfil definido com sucesso.'))
            .catch(e => toastr.error('Erro inesperado', 'Não foi possível definir o perfil do funcionário. Tente novamente em alguns instantes.'))
    }
}